import { Component, inject } from "@angular/core";
import { HotToastRef, HotToastService } from "@ngneat/hot-toast";

@Component({
  selector: "app-error-toast",
  standalone: true,
  imports: [],
  templateUrl: "./error-toast.component.html",
  styleUrl: "./error-toast.component.scss",
})
export class ErrorToastComponent {
  toastRef = inject(HotToastRef);

  constructor(protected toast: HotToastService) {}

  protected copy() {
    navigator.clipboard.writeText(this.toastRef.data.eventId);
    // Optioneel: vervolg-toast ter bevestiging
    ///this.toast.success('Foutcode gekopieerd naar klembord!', { duration: 2000 });
  }
}
